import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../configs/translations'
import { selectCockpitPartnerData, selectCockpitRtm } from '../selectors'

import { useFilteredCockpitPartnerData } from './useFilteredCockpitPartnerData'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.filterPanel

export interface ICockpitPartnersShown {
  /** Partners left by every active filter. */
  shownCount: number
  /** Partners the selected RTM has at all — what `shownCount` is a share of. */
  totalCount: number
  /** i18n key of the whole sentence. The RTM noun lives inside the translation rather than
   *  being composed from the counts, so the sentence can only be built through this key. */
  textKey: string
}

/** The filter panel's "x of y shown" figures. Shared, so the panel and anything quoting it —
 *  an export, say — can never state different numbers. */
export const useCockpitPartnersShown = (): ICockpitPartnersShown => {
  const partnerData = useSelector(selectCockpitPartnerData)
  const selectedRtm = useSelector(selectCockpitRtm)
  const filteredPartners = useFilteredCockpitPartnerData()

  return useMemo(
    () => ({
      shownCount: filteredPartners.length,
      totalCount: partnerData.filter((partner) =>
        selectedRtm === 'resellers' ? partner.IsCommercial === 1 : partner.IsDistributor === 1
      ).length,
      textKey: selectedRtm === 'resellers' ? KEYS.resellersShown : KEYS.distributorsShown,
    }),
    [partnerData, selectedRtm, filteredPartners]
  )
}
